import React,{ Component } from 'react';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle
} from 'reactstrap';

class FloatingWindowLayout extends Component {
  render(){
    return (
      <Container className='FloatingWindowLayout'>
        <Row>
          <Col sm={{size:12,offset:0}} md={{size:6,offset:3}}>
            <div className='hidden-sm-down'>
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <br />
            <Card>
              {this.props.showLogo && (
                <img
                  src={require('../../../shared/assets/dabbl-logo.png')}
                  style={{
                    width:100,
                    marginLeft:'auto',
                    marginTop:30,
                    display:'block',
                    marginRight:'auto',
                    marginBottom:30
                  }}
                  alt='Dabbl Logo'
                />
              )}
              <CardBody>
                {this.props.title && (
                  <CardTitle>
                    {this.props.title}
                  </CardTitle>
                )}
                <br />
                {this.props.children}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    )
  }
}

FloatingWindowLayout.defaultProps = {
  showLogo:true
};

export default FloatingWindowLayout;


// WEBPACK FOOTER //
// ./src/shared/components/FloatingWindowLayout/FloatingWindowLayout.js